import axios from "axios";
import { baseURL } from "../config/api";

export const checkUsername = (username: string) => {
    return axios({
        url: `${baseURL}users/check-username`,
        method: "GET",
        params: {
            username,
        },
    }).then((response) => response.data);
};